import delhiImg from "../../../../assets/cities/delhi.png";
import jaipurImg from "../../../../assets/cities/jaipur.png";
import goaImg from "../../../../assets/cities/goa.png";
import mumbaiImg from "../../../../assets/cities/mumbai.png";
import keralaImg from "../../../../assets/cities/kerala.png";
import ladakhImg from "../../../../assets/cities/ladakh.png";
import manaliImg from "../../../../assets/cities/manali.png";
import andamanImg from "../../../../assets/cities/andaman.png";

export const cityOptions = [
  { label: "New Delhi, India", code: "DEL", short: "New Delhi" },
  { label: "Mumbai, India", code: "BOM", short: "Mumbai" },
  { label: "Jaipur, India", code: "JAI", short: "Jaipur" },
  { label: "Goa, India", code: "GOI", short: "Goa" },
  { label: "Kerala, India", code: "COK", short: "Kerala" },
  { label: "Manali, India", code: "KUU", short: "Manali" },
  { label: "Ladakh, India", code: "IXL", short: "Ladakh" },
  { label: "Andaman, India", code: "IXZ", short: "Andaman" },
  { label: "Dubai, UAE", code: "DXB", short: "Dubai" },
  { label: "Singapore", code: "SIN", short: "Singapore" },
  { label: "Bangkok, Thailand", code: "BKK", short: "Bangkok" },
  { label: "Tokyo, Japan", code: "TYO", short: "Tokyo" },
  { label: "Kuala Lumpur, Malaysia", code: "KUL", short: "Kuala Lumpur" },
  { label: "Paris, France", code: "PAR", short: "Paris" },
  { label: "London, United Kingdom", code: "LON", short: "London" },
  { label: "Phuket, Thailand", code: "HKT", short: "Phuket" },
];

export const categoryChips = [
  { title: "New Delhi", code: "DEL", image: delhiImg },
  { title: "Jaipur", code: "JAI", image: jaipurImg },
  { title: "Mumbai", code: "BOM", image: mumbaiImg },
  { title: "Goa", code: "GOI", image: goaImg },
  { title: "Ladakh", code: "IXL", image: ladakhImg },
  { title: "Kerala", code: "COK", image: keralaImg },
  { title: "Manali", code: "KUU", image: manaliImg },
  { title: "Andaman", code: "IXZ", image: andamanImg },
];

export const sortOptions = ["Traveler Rating", "Price (Low to High)", "Price (High to Low)"];

const delhiActivities = [
  {
    title: "Jai Hind Sound & Light Show at the Red Fort in Delhi",
    location: "New Delhi",
    rating: 4.8,
    reviews: 155,
    duration: "1 hour",
    image: delhiImg,
    price: 500,
    oldPrice: 900,
    desc: "The Red Fort sound & light show brings Delhi's history alive with dramatic narration, music, and vivid projections.",
  },
  {
    title: "Red Fort Centre",
    location: "New Delhi",
    rating: 4.7,
    reviews: 35,
    duration: "1-2 hours",
    image: jaipurImg,
    price: 100,
    oldPrice: 160,
    desc: "Explore curated galleries and immersive exhibits that reveal the stories behind one of India's grandest landmarks.",
  },
  {
    title: "The Great Indian Food Tour",
    location: "Old Delhi",
    rating: 4.9,
    reviews: 82,
    duration: "3 hours",
    image: mumbaiImg,
    price: 3585,
    oldPrice: 4200,
    desc: "Taste legendary street food, hidden snacks, and local favorites with a guided walk through iconic market lanes.",
  },
  {
    title: "Private Heritage Walk with Local Guide",
    location: "New Delhi",
    rating: 4.6,
    reviews: 64,
    duration: "2 hours",
    image: keralaImg,
    price: 1299,
    oldPrice: 1800,
    desc: "Discover old neighborhoods, stories, architecture, and culture through a relaxed private guided experience.",
  },
  {
    title: "Customized Full Day Tour of Old and New Delhi",
    location: "New Delhi",
    rating: 4.7,
    reviews: 96,
    duration: "3 hours to 5 hours",
    image: delhiImg,
    price: 407,
    oldPrice: 850,
    desc: "Customize your day across Old and New Delhi with a flexible route, local stories, and time for the monuments you care about most.",
  },
  {
    title: "All Inclusive Private Taj Mahal Tour from Delhi by Car",
    location: "New Delhi",
    rating: 4.8,
    reviews: 91,
    duration: "12 hours",
    image: jaipurImg,
    price: 407,
    oldPrice: 999,
    desc: "A private full-day trip from Delhi to Agra with comfortable transfers, guided sightseeing, and time at the Taj Mahal.",
  },
  {
    title: "Sunrise Tour Of Taj Mahal From Delhi - All Inclusive",
    location: "New Delhi",
    rating: 4.9,
    reviews: 89,
    duration: "10 hours",
    image: goaImg,
    price: 18332,
    oldPrice: 21999,
    desc: "Start early for a sunrise view of the Taj Mahal, then explore Agra Fort and return to Delhi with a private guide.",
  },
  {
    title: "4-Days Private Golden Triangle Tour India - Delhi Agra Jaipur",
    location: "New Delhi",
    rating: 4.8,
    reviews: 87,
    duration: "4 days",
    image: mumbaiImg,
    price: 29456,
    oldPrice: 34999,
    desc: "Explore Delhi, Agra, and Jaipur on a private multi-day tour with guided monuments, comfortable transfers, and curated stops.",
  },
  {
    title: "Adventures Ranthambore Wildlife Safari Tour from Delhi",
    location: "New Delhi",
    rating: 4.8,
    reviews: 58,
    duration: "3 days",
    image: keralaImg,
    price: 49377,
    oldPrice: 55999,
    desc: "A private wildlife escape from Delhi to Ranthambore with safari time, curated transfers, and a relaxed national park stay.",
  },
  {
    title: "05 Days - Private Luxury Golden Triangle Tour with Delhi",
    location: "New Delhi",
    rating: 4.6,
    reviews: 16,
    duration: "5 days",
    image: jaipurImg,
    price: 48433,
    oldPrice: 58999,
    desc: "Visit Delhi, Agra, and Jaipur on a luxury private Golden Triangle journey with comfortable hotels and guided monuments.",
  },
  {
    title: "Private Evening Tour of Akshardham Temple with Light & Sound Show",
    location: "New Delhi",
    rating: 4.8,
    reviews: 34,
    duration: "4 hours",
    image: delhiImg,
    price: 6518,
    oldPrice: 8200,
    desc: "Experience Akshardham Temple in the evening with its gardens, architecture, cultural exhibits, and light and sound show.",
  },
  {
    title: "4 Days Private Golden Triangle Tour from Delhi - All Inclusive",
    location: "New Delhi",
    rating: 4.7,
    reviews: 14,
    duration: "4 days",
    image: mumbaiImg,
    price: 64285,
    oldPrice: 74999,
    desc: "Cover Delhi, Agra, and Jaipur with private transfers, guided sightseeing, hotel stays, and a complete all-inclusive plan.",
  },
  {
    title: "The best of Rajasthan heritage hotel de lux India tour",
    location: "New Delhi",
    rating: 4.9,
    reviews: 72,
    duration: "8 days",
    image: ladakhImg,
    price: 150734,
    oldPrice: 169999,
    desc: "Travel through Rajasthan's heritage cities with deluxe hotels, palace stays, private transfers, and guided cultural stops.",
  },
];

const mumbaiActivities = [
  {
    title: "Private Guided Walking Tour in Fort & Colaba",
    location: "Mumbai",
    rating: 4.8,
    reviews: 617,
    duration: "2 hours 30 minutes",
    image: mumbaiImg,
    price: 5794,
    oldPrice: 7200,
    desc: "Explore Fort and Colaba on a private walking tour through colonial streets, local landmarks, markets, and city stories.",
  },
  {
    title: "The Original Mumbai by Dawn - Recommended by Locals",
    location: "Mumbai",
    rating: 4.9,
    reviews: 365,
    duration: "3 hours",
    image: keralaImg,
    price: 14217,
    oldPrice: 16800,
    desc: "Start before sunrise and see Mumbai waking up through markets, local food, fishing docks, and everyday city rituals.",
  },
  {
    title: "Private Guided Spiritual Walk in Banganga Hindu Area",
    location: "Mumbai",
    rating: 4.8,
    reviews: 187,
    duration: "2 hours",
    image: goaImg,
    price: 5794,
    oldPrice: 7200,
    desc: "Walk around Banganga Tank and nearby temples with a guide who explains the spiritual stories, traditions, and local life.",
  },
  {
    title: "Private Guided Walking Tour in Bandra Queen of Sea",
    location: "Mumbai",
    rating: 4.6,
    reviews: 178,
    duration: "2 hours 30 minutes",
    image: mumbaiImg,
    price: 5794,
    oldPrice: 7200,
    desc: "Explore Bandra's Portuguese past, coastal lanes, churches, street art, and local stories on a private guided walking tour.",
  },
  {
    title: "2-Hour Guided Tour of Dharavi",
    location: "Mumbai",
    rating: 4.6,
    reviews: 138,
    duration: "2 hours",
    image: jaipurImg,
    price: 1932,
    oldPrice: 2500,
    desc: "Discover Dharavi beyond the usual stereotypes with a guided walk through workshops, homes, markets, and local enterprise.",
  },
  {
    title: "Dharavi Slum Tour Experience with a Local English Guide",
    location: "Mumbai",
    rating: 4.6,
    reviews: 128,
    duration: "2 hours",
    image: keralaImg,
    price: 820,
    oldPrice: 1200,
    desc: "See the hidden treasures of Dharavi with a local English-speaking guide and learn about daily life, work, and community.",
  },
  {
    title: "Heritage Walk: Recommended by Gigi Hadid as a Mumbai Experience",
    location: "Mumbai",
    rating: 4.7,
    reviews: 70,
    duration: "3 to 4 hours",
    image: mumbaiImg,
    price: 7149,
    oldPrice: 8600,
    desc: "Explore Mumbai's tourist precinct on foot with a guided heritage walk through landmarks, stories, and local culture.",
  },
  {
    title: "Dabbawala, Dhobi Ghat & Dharavi Slum Tour with Local Guide",
    location: "Mumbai",
    rating: 4.8,
    reviews: 66,
    duration: "4 hours",
    image: keralaImg,
    price: 3863,
    oldPrice: 4800,
    desc: "Meet Mumbai's famous dabbawalas, visit Dhobi Ghat, and understand Dharavi's everyday life with a local guide.",
  },
  {
    title: "Mumbai sightseeing tour with pickup",
    location: "Mumbai",
    rating: 4.7,
    reviews: 60,
    duration: "6 hours",
    image: delhiImg,
    price: 5795,
    oldPrice: 7200,
    desc: "Enjoy a private guided day tour in Mumbai with pickup, covering major landmarks and flexible stops as per your plan.",
  },
  {
    title: "Tour of Dharavi Slum",
    location: "Mumbai",
    rating: 4.6,
    reviews: 56,
    duration: "3 to 4 hours",
    image: jaipurImg,
    price: 1304,
    oldPrice: 1900,
    desc: "Walk through Dharavi with a guide and learn about its industries, homes, community networks, and daily life.",
  },
];

const goaActivities = [
  {
    title: "Fontainhas Tales & Trails: E-Bike Adventure Journey",
    location: "Goa",
    rating: 4.8,
    reviews: 121,
    duration: "2 hours 30 minutes",
    image: goaImg,
    price: 2607,
    oldPrice: 3400,
    desc: "Ride through Panjim's Fontainhas quarter on an e-bike and discover colorful streets, cultural heritage, and scenic city highlights.",
  },
  {
    title: "Saligao Village Saunter by Make It Happen",
    location: "Goa",
    rating: 4.7,
    reviews: 52,
    duration: "2 hours 30 minutes",
    image: keralaImg,
    price: 1168,
    oldPrice: 1800,
    desc: "Walk through Saligao, one of Goa's prosperous villages, and explore its architecture, stories, local lanes, and creative spirit.",
  },
  {
    title: "Glimpses Of Goa",
    location: "Goa",
    rating: 4.6,
    reviews: 46,
    duration: "7 hours",
    image: jaipurImg,
    price: 11490,
    oldPrice: 13800,
    desc: "Spend the day exploring Goa's capital, old Latin quarters, Panjim photo stops, and key cultural highlights with a guided route.",
  },
  {
    title: "Fontainhas Heritage Walk With Guide Mario",
    location: "Goa",
    rating: 4.8,
    reviews: 24,
    duration: "2 hours",
    image: delhiImg,
    price: 1630,
    oldPrice: 2200,
    desc: "Explore Panjim on foot through Fontainhas, heritage streets, old churches, and local stories with a guided walking experience.",
  },
  {
    title: "Latin Quarter Food Trail by Make It Happen",
    location: "Goa",
    rating: 4.9,
    reviews: 14,
    duration: "3 hours 15 minutes",
    image: keralaImg,
    price: 2414,
    oldPrice: 3100,
    desc: "Taste Portuguese-Goan flavors while walking through the Latin Quarter and learning about local cuisine, culture, and history.",
  },
  {
    title: "2-Day Tour to The Taj Mahal and Agra from Goa with Flights",
    location: "Goa",
    rating: 4.7,
    reviews: 12,
    duration: "2 days",
    image: jaipurImg,
    price: 58664,
    oldPrice: 67999,
    desc: "Take a private two-day tour from Goa to Agra with flights, transfers, and guided visits to the Taj Mahal and key monuments.",
  },
];

const jaipurActivities = [
  {
    title: "3-Hour Morning Bike Tour of Jaipur",
    location: "Jaipur",
    rating: 4.9,
    reviews: 673,
    duration: "3 hours",
    image: jaipurImg,
    price: 2607,
    oldPrice: 3400,
    desc: "Ride through Jaipur in the morning, explore local lanes, historic spots, and street food with a guided cycling experience.",
  },
  {
    title: "Private Full Day Jaipur Sightseeing Tour By Tuk Tuk",
    location: "Jaipur",
    rating: 4.8,
    reviews: 270,
    duration: "8 hours 30 minutes",
    image: delhiImg,
    price: 1003,
    oldPrice: 1600,
    desc: "Explore Jaipur by tuk-tuk with a private local driver and visit iconic palaces, monuments, museums, and markets.",
  },
  {
    title: "Private Jaipur Full One Day Tour In Pink City With Guide",
    location: "Jaipur",
    rating: 4.8,
    reviews: 245,
    duration: "6 to 8 hours",
    image: goaImg,
    price: 733,
    oldPrice: 1200,
    desc: "Spend a full day exploring Jaipur's Pink City landmarks including Hawa Mahal, City Palace, forts, and cultural stops.",
  },
  {
    title: "Full-day Jaipur Private Sightseeing Tour by Car with Driver",
    location: "Jaipur",
    rating: 4.8,
    reviews: 207,
    duration: "8 hours",
    image: mumbaiImg,
    price: 6567,
    oldPrice: 8200,
    desc: "Travel across Jaipur in a private car and visit Amber Fort, palaces, local markets, and major landmarks with comfort.",
  },
  {
    title: "Day Tour Of Jaipur With Driver & Car",
    location: "Jaipur",
    rating: 4.8,
    reviews: 173,
    duration: "8 hours",
    image: goaImg,
    price: 3694,
    oldPrice: 4700,
    desc: "Enjoy a transparent private Jaipur day tour with driver and car, covering the city's most loved highlights at your pace.",
  },
  {
    title: "Jaipur Full Day Guided Tour",
    location: "Jaipur",
    rating: 4.8,
    reviews: 155,
    duration: "8 to 10 hours",
    image: keralaImg,
    price: 3863,
    oldPrice: 4900,
    desc: "Experience Jaipur with a private guide, visiting City Palace, Water Palace, forts, bazaars, and the city's best photo stops.",
  },
  {
    title: "2-Day Private Jaipur City Sightseeing Tour with Local Guide",
    location: "Jaipur",
    rating: 4.9,
    reviews: 130,
    duration: "2 days",
    image: jaipurImg,
    price: 10592,
    oldPrice: 12800,
    desc: "Explore Jaipur over two days with a private guide, covering must-see palaces, forts, old city lanes, and cultural stops.",
  },
];

const keralaActivities = [
  {
    title: "Zamorin's Tales by Tyndis - Calicut Heritage Walk",
    location: "Kerala",
    rating: 4.8,
    reviews: 14,
    duration: "3 hours",
    image: keralaImg,
    price: 2037,
    oldPrice: 2800,
    desc: "Walk through Calicut's heritage points, old trade routes, local stories, and historic neighborhoods with a guided experience.",
  },
  {
    title: "Affordable Calicut Airport Transfer",
    location: "Kerala",
    rating: 4.5,
    reviews: 2,
    duration: "1 hour 30 minutes",
    image: goaImg,
    price: 2176,
    oldPrice: 3000,
    desc: "Book a comfortable airport transfer from Calicut Airport to your destination with verified chauffeur and arrival assistance.",
  },
  {
    title: "Kochi (India) Shore Excursions Pick & Drop @ Ship",
    location: "Kerala",
    rating: 4.6,
    reviews: 1,
    duration: "6 to 8 hours",
    image: keralaImg,
    price: 10185,
    oldPrice: 12400,
    desc: "Enjoy a private Kochi shore excursion with ship pickup, local sightseeing, flexible stops, and drop back after the tour.",
  },
  {
    title: "Private Jatayu Nature Park and Varkala Beach Tour",
    location: "Kerala",
    rating: 4.6,
    reviews: 1,
    duration: "7 to 8 hours",
    image: ladakhImg,
    price: 7903,
    oldPrice: 9800,
    desc: "Visit Jatayu Earth's Center and Varkala Beach on a private day tour from Trivandrum or Kovalam with comfortable transfers.",
  },
  {
    title: "Flavors of North Kerala - Malabar Experiential Tour",
    location: "Kerala",
    rating: 4.7,
    reviews: 11,
    duration: "Full day",
    image: keralaImg,
    price: 52339,
    oldPrice: 61000,
    desc: "Explore North Kerala's monuments, local flavors, cultural stops, and Malabar experiences through a curated guided tour.",
  },
  {
    title: "Into the Mangroves: Calicut Mangrove Trail by Tyndis",
    location: "Kerala",
    rating: 4.8,
    reviews: 10,
    duration: "2 hours",
    image: goaImg,
    price: 5296,
    oldPrice: 6800,
    desc: "Walk through Calicut's mangrove trails and learn about conservation, community stories, and the region's natural ecology.",
  },
  {
    title: "Tuk Tuk Tour in Calicut with Storyteller by Tyndis",
    location: "Kerala",
    rating: 4.4,
    reviews: 2,
    duration: "3 hours",
    image: jaipurImg,
    price: 2384,
    oldPrice: 3100,
    desc: "Explore Calicut by tuk tuk with a storyteller, visiting local markets, heritage corners, everyday streets, and cultural stops.",
  },
];

const manaliActivities = [
  {
    title: "Private One Day Hiking Trip in Manali, Scenic Mountain Trail",
    location: "Manali",
    rating: 4.8,
    reviews: 5,
    duration: "5 to 8 hours",
    image: ladakhImg,
    price: 3739,
    oldPrice: 4800,
    desc: "Enjoy a private day hike in Manali through scenic mountain paths, forests, and high-altitude views with a guided route.",
  },
  {
    title: "Motorbike Tour To Leh Ladakh",
    location: "Manali",
    rating: 4.7,
    reviews: 2,
    duration: "Multi-day",
    image: mumbaiImg,
    price: 78219,
    oldPrice: 89999,
    desc: "Ride from Manali toward Ladakh through Rohtang Pass, Keylong, Jispa, Baralacha La, Leh, and high mountain landscapes.",
  },
  {
    title: "Patalsu Peak Trek",
    location: "Manali",
    rating: 4.8,
    reviews: 1,
    duration: "3 days",
    image: keralaImg,
    price: 6277,
    oldPrice: 7800,
    desc: "Trek to Patalsu Peak near Manali and experience a beginner-friendly high-altitude trail with panoramic Himalayan views.",
  },
  {
    title: "Explore Manali",
    location: "Manali",
    rating: 4.6,
    reviews: 1,
    duration: "6 hours",
    image: manaliImg,
    price: 24850,
    oldPrice: 29900,
    desc: "Explore Manali's temples, forests, river views, and mountain charm through a guided local sightseeing experience.",
  },
  {
    title: "Bhrigu Lake and Alpine Meadow Trek",
    location: "Manali",
    rating: 4.7,
    reviews: 70,
    duration: "3 days",
    image: ladakhImg,
    price: 43346,
    oldPrice: 52000,
    desc: "Learn trail craft, camp skills, and mountain safety while trekking through alpine meadows toward Bhrigu Lake.",
  },
  {
    title: "Friendship Peak Trek",
    location: "Manali",
    rating: 4.7,
    reviews: 62,
    duration: "8 days",
    image: keralaImg,
    price: 75385,
    oldPrice: 89000,
    desc: "Take on a high-altitude trekking expedition with experienced leaders, mountain views, and a personalized learning experience.",
  },
  {
    title: "Exotic Manali Package",
    location: "Manali",
    rating: 4.6,
    reviews: 13,
    duration: "4 days",
    image: manaliImg,
    price: 19229,
    oldPrice: 23500,
    desc: "Enjoy a curated Manali package with sightseeing, mountain scenery, comfortable travel, and relaxed vacation time.",
  },
];

const ladakhActivities = [
  {
    title: "Ladakh 6 Days and 5 Nights",
    location: "Leh",
    rating: 4.8,
    reviews: 115,
    duration: "6 days",
    image: ladakhImg,
    price: 81478,
    oldPrice: 95000,
    desc: "Explore Leh, Nubra, Pangong, monasteries, palaces, markets, and high-altitude highlights on a curated Ladakh itinerary.",
  },
  {
    title: "Ladakh Private Tours",
    location: "Leh",
    rating: 4.7,
    reviews: 46,
    duration: "7 days",
    image: manaliImg,
    price: 81478,
    oldPrice: 95000,
    desc: "Take a private Ladakh journey covering Nubra Valley, Khardungla, Pangong Lake, monasteries, local markets, and scenic passes.",
  },
  {
    title: "Ladakh Sham Valley Trek",
    location: "Leh",
    rating: 4.6,
    reviews: 7,
    duration: "3 days",
    image: ladakhImg,
    price: 40739,
    oldPrice: 49800,
    desc: "Try the Sham Valley trek, a short beginner-friendly route through rugged landscapes, villages, and mountain trails.",
  },
  {
    title: "Mountain Homestays - Sumda Chun Monastery Walk",
    location: "Leh",
    rating: 4.8,
    reviews: 1,
    duration: "5 to 6 hours",
    image: ladakhImg,
    price: 11575,
    oldPrice: 14900,
    desc: "Experience Ladakh's ancient heritage and local life with a guided visit to Sumda Chun Monastery and nearby homestay village.",
  },
  {
    title: "Private 4 Days Delightful Ladakh Tour",
    location: "Leh",
    rating: 4.8,
    reviews: 1,
    duration: "4 days",
    image: manaliImg,
    price: 65100,
    oldPrice: 77000,
    desc: "Discover Ladakh with a private four-day itinerary covering scenic drives, cultural sites, and high-altitude landscapes.",
  },
  {
    title: "Leh to Nubra Valley Private Tour",
    location: "Leh",
    rating: 4.8,
    reviews: 1,
    duration: "2 days",
    image: ladakhImg,
    price: 49457,
    oldPrice: 59000,
    desc: "Travel from Leh to Nubra Valley through Khardung La and enjoy dramatic mountain views, villages, and valley landscapes.",
  },
  {
    title: "Mountain Homestays - Journey to Siachen Valley",
    location: "Leh",
    rating: 4.8,
    reviews: 1,
    duration: "7 days",
    image: keralaImg,
    price: 58514,
    oldPrice: 69500,
    desc: "Explore hidden places, customs, and community life around Siachen Valley with a curated mountain homestay journey.",
  },
];

const andamanActivities = [
  {
    title: "Private Transfer from Port Blair to Veer Savarkar Airport",
    location: "Andaman And Nicobar Islands",
    rating: 4.7,
    reviews: 1,
    duration: "25 minutes",
    image: andamanImg,
    price: 3480,
    oldPrice: 4300,
    desc: "Book a comfortable private transfer to Veer Savarkar Airport with hotel pickup, easy travel, and no taxi queues.",
  },
  {
    title: "Game Fishing & Luxury Private Charters in Andaman",
    location: "Andaman And Nicobar Islands",
    rating: 4.8,
    reviews: 1,
    duration: "5 hours",
    image: goaImg,
    price: 74593,
    oldPrice: 86000,
    desc: "Explore Andaman's secluded islands and beaches with private charter activities like fishing, island hopping, and cruising.",
  },
  {
    title: "Andaman FlyAir Parasailing",
    location: "Andaman And Nicobar Islands",
    rating: 4.8,
    reviews: 34,
    duration: "1 hour",
    image: andamanImg,
    price: 2983,
    oldPrice: 3900,
    desc: "Enjoy a thrilling parasailing experience in Andaman with trained crew, safety checks, and sweeping sea views.",
  },
];

export const activitiesByCity = {
  DEL: delhiActivities,
  BOM: mumbaiActivities,
  GOI: goaActivities,
  JAI: jaipurActivities,
  COK: keralaActivities,
  KUU: manaliActivities,
  IXL: ladakhActivities,
  IXZ: andamanActivities,
  DXB: [delhiActivities[0]],
  SIN: [delhiActivities[0]],
  BKK: [delhiActivities[0]],
  TYO: [delhiActivities[0]],
  KUL: [delhiActivities[0]],
  PAR: [delhiActivities[0]],
  LON: [delhiActivities[0]],
  HKT: [delhiActivities[0]],
};

export const filterGroups = [
  { title: "Duration", lines: ["Up to 1 hour", "1 to 4 hours", "4 hours to 1 day", "1 to 3 days", "More than 3 days"] },
  { title: "User Rating", lines: ["5 stars", "4 stars & up", "3 stars & up", "2 stars & up"] },
  { title: "Specials", lines: ["Free Cancellation", "Skip The Line", "Private Tour", "Special Offer"] },
];

export function formatPrice(value) {
  return `Rs. ${Number(value).toLocaleString("en-IN")}`;
}

function normalize(value) {
  return String(value || "").trim().toLowerCase();
}

export function getActiveCity(querySource) {
  const query = querySource instanceof URLSearchParams
    ? querySource
    : new URLSearchParams(querySource || "");
  const queryCode = query.get("toCode");
  const queryCity = query.get("city");
  const byCode = cityOptions.find((city) => city.code === queryCode);
  const byName = cityOptions.find((city) => normalize(city.short) === normalize(queryCity));

  return byCode || byName || cityOptions[0];
}

export function getCitiesActivitiesPage(querySource) {
  const activeCity = getActiveCity(querySource);

  return {
    activeCity,
    activities: activitiesByCity[activeCity.code] || activitiesByCity.DEL,
    categoryChips,
    cityOptions,
    filterGroups,
    sortOptions,
  };
}

export function getVisibleActivities(activities, { search = "", sort = "" } = {}) {
  const searchText = normalize(search);
  const filteredActivities = searchText
    ? activities.filter((activity) => {
        const haystack = normalize(`${activity.title} ${activity.location} ${activity.desc}`);
        return haystack.includes(searchText);
      })
    : [...activities];

  if (sort === "Traveler Rating") {
    return filteredActivities.sort((a, b) => b.rating - a.rating || b.reviews - a.reviews);
  }

  if (sort === "Price (Low to High)") {
    return filteredActivities.sort((a, b) => a.price - b.price);
  }

  if (sort === "Price (High to Low)") {
    return filteredActivities.sort((a, b) => b.price - a.price);
  }

  return filteredActivities;
}
